export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_11.7f5e7160.jpg";